<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row mt-4">
      <div class="col-sm-6">
        <div class="media">
          <div class="avatar-sm mr-3">
            <span
              class="avatar-title rounded-circle bg-primary text-white font-size-22"
            >
              <i class="bx bxl-instagram"></i>
            </span>
          </div>
          <div class="media-body">
            <b class="text-muted mb-1"
              >{{ totalAccount }} {{ $t("instagram.account") }}</b
            >
            <h4>{{ $t("instagram.last-search-accounts") }}</h4>
          </div>
        </div>
      </div>
      <div class="col-sm-6 text-right">
        <router-link to="/instagram-compare"
          ><b-button class="btn mr-1" variant="success"
            ><i class="bx bx-user-plus bx-xl"></i> Compare Account</b-button
          ></router-link
        >
        <router-link to="/instagram/search"
          ><b-button class="btn" variant="primary"
            ><i class="bx bx-user-plus bx-xl"></i>
            {{ $t("twitter.add-new.text") }}</b-button
          ></router-link
        >
      </div>
    </div>

    <div class="row mt-2 mb-4">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row mt-4">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    {{ $t("button.show") }}&nbsp;&nbsp;
                    <b-form-select
                      v-model="perPage"
                      size="sm"
                      :options="pageOptions"
                      class="mx-0"
                    ></b-form-select
                    >&nbsp;&nbsp;{{ $t("button.entries") }}
                  </label>
                  <b-button
                    class="btn btn-sm ml-3"
                    variant="danger"
                    @click="bulkAction()"
                    v-if="selected[0]"
                    >{{ $t("button.bulk") }} : {{ selected.length }}
                    {{ $t("button.row-data") }}</b-button
                  >
                </div>
              </div>
              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div
                  id="tickets-table_filter"
                  class="dataTables_filter text-md-right"
                >
                  <label class="d-inline-flex align-items-center">
                    {{ $t("button.search-data") }}:
                    <b-form-input
                      v-model="filter"
                      type="search"
                      :placeholder="$t('all.searchh')"
                      class="form-control form-control ml-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>
            <!-- Table -->
            <div class="table-responsive mb-0">
              <b-table
                :items="tableData"
                :fields="fields"
                striped
                bordered
                responsive="sm"
                :per-page="perPage"
                :current-page="currentPage"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                :filter="filter"
                :filter-included-fields="filterOn"
              >
                <template #head(bulk)>
                  <b-form-checkbox
                    v-model="selectAll"
                    @change="select"
                    class="text-center mt-0"
                  >
                  </b-form-checkbox>
                </template>
                <template #cell(no)="row">
                  <div class="mt-2">
                    {{ row.item.no }}
                  </div>
                </template>
                <template #cell(bulk)="row">
                  <b-form-checkbox
                    class="text-center mt-2"
                    v-model="selected"
                    :value="row.item.id_instagram"
                  >
                  </b-form-checkbox>
                </template>
                <template #cell(account)="row">
                  <div class="col-sm-12">
                    <div class="media">
                      <img
                        :src="avatar + row.item.picture"
                        class="mr-3 mt-3 rounded-circle avatar-xs"
                        alt="user-pic"
                        v-if="row.item.picture_hd"
                      />
                      <img
                        :src="row.item.picture"
                        alt="img"
                        class="mr-3 mt-2 rounded-circle avatar-xs"
                        v-if="row.item.picture && !row.item.picture_hd"
                      />
                      <img
                        :src="
                          theme == 'dark'
                            ? 'https://img.icons8.com/ios/240/FFFFFF/user-male-circle.png'
                            : 'https://img.icons8.com/ios/240/000000/user-male-circle.png'
                        "
                        class="mr-3 mt-3 rounded-circle avatar-xs"
                        alt="user-pic"
                        v-if="!row.item.picture && !row.item.picture_hd"
                      />
                      <div class="media-body">
                        <b> {{ row.item.full_name }}</b>
                        <span v-if="row.item.verified == 1"
                          ><i
                            class="my-auto ml-1 text-primary mdi mdi-check-decagram mdi-18px"
                          ></i
                        ></span>
                        <br />
                        <span class="text-secondary">
                          @{{ row.item.account }}</span
                        >
                        <br />
                        <!-- <p class="text-secondary">{{ $t('all.updated') }}: {{row.item.updated_at}} </p>  -->
                      </div>
                    </div>
                  </div>
                </template>
                <template #cell(pin)="row">
                  <span v-if="row.item.pin">
                    <i
                      class="bx bxs-pin bx-sm text-primary"
                      @click="unpin(row.item.id_instagram)"
                    ></i>
                  </span>
                  <span v-else>
                    <i
                      class="bx bx-pin bx-sm text-secondary"
                      @click="pin(row.item.id_instagram)"
                    ></i>
                  </span>
                </template>
                <template #cell(actions)="row">
                  <router-link
                    :to="{
                      name: 'instagram-view',
                      params: { id: row.item.account },
                    }"
                    ><b-button
                      class="mr-1 btn-sm mb-1"
                      variant="secondary"
                      title="Show detail"
                    >
                      <i class="bx bx-show-alt"></i> </b-button
                  ></router-link>
                  <b-button
                    class="mr-1 btn-sm mb-1"
                    variant="danger"
                    @click="deleteInstagram(row.item.id_instagram)"
                    title="Delete"
                  >
                    <i class="bx bx-trash"></i>
                  </b-button>
                </template>
              </b-table>

              <div v-if="loadingInfo" class="mt-4 mx-auto p-5">
                <div class="text-center">
                  <div
                    class="spinner-border text-secondary"
                    role="status"
                    v-if="loadingInfo"
                  ></div>
                </div>
              </div>
            </div>
            <div class="row" v-if="!loadingInfo && rows > 10">
              <div class="col-2 col-xl-1">
                <!-- <div v-if="selected[0]">
                      <b-button class="btn btn-sm" variant="danger" @click="bulkAction()">Bulk Delete : {{selected.length}} Rows Data</b-button>
                    </div> -->
                <label class="d-inline-flex align-items-center">
                  Page
                  <b-form-input
                    v-model="currentPage"
                    placeholder="Page"
                    class="form-control w-10 form-control ml-2"
                  ></b-form-input>
                </label>
              </div>
              <div class="col-10 col-xl-11 text-right" v-if="rows > 10">
                <div
                  class="dataTables_paginate paging_simple_numbers float-right"
                >
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="rows"
                      :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import InstaService from "@/helpers/osintgram.service.js";
import Layout from "../../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import axios from "axios";
import moment from "moment";
import Particle from "./particle.vue";
import SocmedService from "@/helpers/socmed.service";
import Swal from "sweetalert2";
import PreferenceService from "@/helpers/preference.service.js";
// import { tableData } from "./dataAdvancedtable";

export default {
  page: {
    title: "Tools Instagram",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout, PageHeader, Particle },
  data() {
    return {
      theme: localStorage.getItem("theme"),
      avatar: process.env.VUE_APP_BASE_API_URL_OSINT + "stream-profil/?name=",
      pref_userinfo: {
        api_host: "",
        x_rapidapi_host: "",
        x_rapidapi_key: "",
      },
      pref_userinfo2: {
        api_host: "",
        x_rapidapi_host: "",
        x_rapidapi_key: "",
      },
      pref_search: {
        api_host: "",
        x_rapidapi_host: "",
        x_rapidapi_key: "",
      },
      pref_search2: {
        api_host: "",
        x_rapidapi_host: "",
        x_rapidapi_key: "",
      },
      pref_avatar: {
        api_host: "",
        x_rapidapi_host: "",
        x_rapidapi_key: "",
      },
      avatar_instagram:
        "https://img.icons8.com/ios/240/000000/user-male-circle.png",
      loading: false,
      search: false,
      result: false,
      totalResult: "",
      error: "",
      dnf: false,
      searchKey: "",
      loadingInfo: false,
      searchResult: [],
      searchResultOsint: [],
      tableData: [],
      selected: [],
      selectAll: false,
      search: false,
      title: "Instagram",
      items: [
        {
          text: "Dashboard",
          href: "/",
        },
        {
          text: "Instagram",
          active: true,
        },
      ],
      totalRows: 1,
      totalAccount: "",
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      filter: null,
      filterOn: [],
      sortBy: "age",
      sortDesc: false,
      fields: [
        {
          key: "no",
          class: "text-center",
          thStyle: { width: "3%" },
          label: "No",
        },
        { key: "bulk", thStyle: { width: "2%" }, label: "#" },
        { key: "id_instagram", thClass: "d-none", tdClass: "d-none" },
        { key: "user_id", thClass: "d-none", tdClass: "d-none" },
        { key: "picture", thClass: "d-none", tdClass: "d-none" },
        { key: "updated_at", thClass: "d-none", tdClass: "d-none" },
        { key: "full_name", thClass: "d-none", tdClass: "d-none" },
        { key: "account", sortable: true, label: this.$t("instagram.account") },
        {
          key: "followers",
          sortable: true,
          label: this.$t("instagram.followers"),
        },
        {
          key: "following",
          sortable: true,
          label: this.$t("instagram.following"),
        },
        { key: "media", sortable: true, label: this.$t("instagram.post") },
        { key: "pin", class: "text-center", label: "Pin" },
        {
          key: "actions",
          class: "text-center",
          label: this.$t("instagram.action"),
        },
      ],
    };
  },
  computed: {
    rows() {
      return this.tableData.length;
    },
  },
  methods: {
    getPreferencesSearch() {
      let id = 10;
      PreferenceService.getRapidApiByID(id)
        .then((response) => {
          // console.log(response.data.data);
          // this.pref = response.data.data;
          this.pref_search.api_host = response.data.data.api_host;
          this.pref_search.x_rapidapi_host = response.data.data.api_header_host;
          this.pref_search.x_rapidapi_key = response.data.data.api_header_key;
        })
        .catch((err) => {
          console.log(err);
        });
    },

    getPreferencesSearch2() {
      let id = 11;
      PreferenceService.getRapidApiByID(id)
        .then((response) => {
          // console.log(response.data.data);
          // this.pref_search = response.data.data;
          this.pref_search2.api_host = response.data.data.api_host;
          this.pref_search2.x_rapidapi_host =
            response.data.data.api_header_host;
          this.pref_search2.x_rapidapi_key = response.data.data.api_header_key;
        })
        .catch((err) => {
          console.log(err);
        });
    },

    getPreferencesAvatar() {
      let id = 62;
      PreferenceService.getRapidApiByID(id)
        .then((response) => {
          console.log("avatar", response.data.data);
          // this.pref_search = response.data.data;
          this.pref_avatar.api_host = response.data.data.api_host;
          this.pref_avatar.x_rapidapi_host = response.data.data.api_header_host;
          this.pref_avatar.x_rapidapi_key = response.data.data.api_header_key;
        })
        .catch((err) => {
          console.log(err);
        });
    },

    getPreferencesUserInfo() {
      let id = 13;
      PreferenceService.getRapidApiByID(id)
        .then((response) => {
          // console.log(response.data.data);
          // this.pref_userinfo = response.data.data;
          this.pref_userinfo.api_host = response.data.data.api_host;
          this.pref_userinfo.x_rapidapi_host =
            response.data.data.api_header_host;
          this.pref_userinfo.x_rapidapi_key = response.data.data.api_header_key;
        })
        .catch((err) => {
          console.log(err);
        });
    },

    getPreferencesUserInfo2() {
      let id = 14;
      PreferenceService.getRapidApiByID(id)
        .then((response) => {
          // console.log(response.data.data);
          // this.pref_userinfo = response.data.data;
          this.pref_userinfo2.api_host = response.data.data.api_host;
          this.pref_userinfo2.x_rapidapi_host =
            response.data.data.api_header_host;
          this.pref_userinfo2.x_rapidapi_key =
            response.data.data.api_header_key;
        })
        .catch((err) => {
          console.log(err);
        });
    },

    searchIntagram() {
      this.error = "";
      this.result = false;
      this.dnf = false;
      let searchData = this.removeSpace(this.searchKey);
      if (this.searchKey != "") {
        this.search = true;
        this.loading = true;
        this.searchResult = [];
        this.searchResultOsint = [];
        let headers = {
          "content-type": "application/json",
          "x-rapidapi-host": this.pref_search.x_rapidapi_host,
          "x-rapidapi-key": this.pref_search.x_rapidapi_key,
        };

        return axios
          .get(this.pref_search.api_host + "?user=" + searchData, {
            headers: headers,
          })
          .then((response) => {
            this.searchResult = response.data.users;
            // console.log(response.data.users);
            // let total = response.data.pagination['total'];
            this.totalResult = this.searchResult.length;

            this.loading = false;
            this.result = true;
          })
          .catch((err) => {
            console.log(err);
            this.searchIntagram2();
          });
      }
    },

    searchIntagram2() {
      this.error = "";
      this.result = false;
      this.dnf = false;
      let searchData = this.removeSpace(this.searchKey);
      if (this.searchKey != "") {
        this.search = true;
        this.loading = true;
        this.searchResult = [];
        this.searchResultOsint = [];
        let headers = {
          "content-type": "application/json",
          "x-rapidapi-host": this.pref_search2.x_rapidapi_host,
          "x-rapidapi-key": this.pref_search2.x_rapidapi_key,
        };
        // console.log(headers);
        return axios
          .get(this.pref_search2.api_host + "?user=" + searchData, {
            headers: headers,
          })
          .then((response) => {
            this.searchResult = response.data.users;
            // console.log(response.data.users);
            // let total = response.data.pagination['total'];
            this.totalResult = this.searchResult.length;

            this.loading = false;
            this.result = true;
          })
          .catch((err) => {
            console.log(err);
            this.searchIntagramOsint();
            // if( err.response.status == 500 ){
            //     this.error = "Internal server Error";
            //     this.searchIntagramOsint();
            //   } else if( err.response.status == 404 ){
            //     this.error = "Server Not Found";
            //     this.searchIntagramOsint();
            //   } else if( err.response.status == 403 ){
            //     this.error = "Forbidden";
            //     this.searchIntagramOsint();
            //   } else if( err.response.status == 504 ){
            //     this.error = "Timeout";
            //     this.searchIntagramOsint();
            //   } else {
            //     this.searchIntagramOsint();
            //   }
          });
      }
    },

    searchIntagramOsint() {
      this.error = "";
      this.result = false;
      this.dnf = false;
      const data = {
        nama: this.searchKey,
      };
      if (this.searchKey != "") {
        this.search = true;
        this.loading = true;
        this.searchResultOsint = [];
        this.searchResult = [];
        InstaService.search(data)
          .then((response) => {
            this.searchResultOsint.push(response.data.output);
            this.totalResult = response.data.output.length;
            let total = response.data.output.length;
            if (total == 0) {
              this.dnf = true;
            }
            this.loading = false;
            this.result = true;
          })
          .catch((err) => {
            console.log(err);
            if (err.response.status == 500) {
              this.error = this.$t("all.error-500");
            } else if (err.response.status == 404) {
              this.error = this.$t("all.error-404");
            }
            this.search = false;
            this.loading = false;
          });
      }
    },

    select() {
      // console.log('selected');
      this.selected = [];
      if (!this.selectAll) {
        for (let i in this.tableData) {
          this.selected.push(this.tableData[i].id_instagram);
        }
      }
    },

    listInstagram() {
      (this.loadingInfo = true),
        SocmedService.getAllInstagram()
          .then((response) => {
            this.tableData = [];
            this.totalAccount = response.data.data.length;
            response.data.data.forEach((val, index) => {
              const data = {
                no: index + 1,
                id_instagram: val.id_instagram,
                user_id: val.user_id,
                account: val.account,
                full_name: val.full_name,
                verified: val.is_verified,
                picture: val.picture,
                picture_hd: val.picture_hd,
                followers: val.followers,
                following: val.following,
                media: val.media,
                pin: val.pin,
                created_at: this.formatDate(val.created_at),
                updated_at: this.formatDate(val.updated_at),
              };
              this.tableData.push(data);
              this.loadingInfo = false;
            });
          })
          .catch((err) => {
            console.log(err);
            this.loadingInfo = false;
          });
    },

    addInstagram(username) {
      var account = username;
      Swal.fire({
        title: this.$t("alert.alert-add") + username + " ?",
        showCancelButton: true,
        confirmButtonText: "Save",
        confirmButtonColor: "#0067AC",
      }).then((result) => {
        if (result.isConfirmed) {
          this.getAvatarInstagram(username);
          this.loading = true;
          this.searchResult = [];
          var data = {
            nama: username,
          };
          InstaService.getUsername(data)
            .then((response) => {
              var data_akun = response.data.output;
              this.saveInstagram(data_akun);
              // console.log(response.data.output)
            })
            .catch((err) => {
              console.log(err);
              this.addInstagramRapid(account);
            });
        }
      });
    },

    getAvatarInstagram(username) {
      // if (this.searchKey != "") {
      let headers = {
        "content-type": "application/json",
        "x-rapidapi-host": this.pref_avatar.x_rapidapi_host,
        "x-rapidapi-key": this.pref_avatar.x_rapidapi_key,
      };
      // console.log(headers);
      return axios
        .get(
          this.pref_avatar.api_host +
            "?url=https://www.instagram.com/" +
            username +
            "/",
          { headers: headers }
        )
        .then((response) => {
          // console.log('avatar', response.data.data.image);
          this.avatar_instagram = response.data.data.image;
        })
        .catch((err) => {
          console.log(err);
          //   }
        });
      // }
    },

    addInstagramRapid(username) {
      this.loading = true;
      this.searchResult = [];
      var user = username;
      let headers = {
        "content-type": "application/json",
        "x-rapidapi-host": this.pref_userinfo.x_rapidapi_host,
        "x-rapidapi-key": this.pref_userinfo.x_rapidapi_key,
      };
      console.log(headers);
      return axios
        .get(this.pref_userinfo.api_host + "?username=" + user, {
          headers: headers,
        })
        .then((response) => {
          var val = response.data;

          let data = {
            pk: val.id,
            username: val.username,
            full_name: val.full_name,
            biography: val.biography,
            following_count: val.edge_follow.count,
            follower_count: val.edge_followed_by.count,
            media_count: val.edge_owner_to_timeline_media.count,
            is_private: val.is_private,
            is_verified: val.is_verified,
            is_business: val.is_business_account,
            picture: val.profile_pic_url,
            picture_hd: val.profile_pic_url_hd,
            public_email: val.business_email,
            contact_phone_number: val.business_phone_number,
            bussiness_category_name: val.business_category_name,
            category_name: val.category_name,
          };
          this.saveInstagram(data);
        })
        .catch((err) => {
          this.addInstagramRapid2(user);
          console.log(err);
        });
    },

    addInstagramRapid2(username) {
      this.loading = true;
      this.searchResult = [];
      let user = username;
      let headers = {
        "content-type": "application/json",
        "x-rapidapi-host": this.pref_userinfo2.x_rapidapi_host,
        "x-rapidapi-key": this.pref_userinfo2.x_rapidapi_key,
      };
      console.log(headers);
      return axios
        .get(this.pref_userinfo2.api_host + "?username=" + user, {
          headers: headers,
        })
        .then((response) => {
          var val = response.data;
          let data = {
            pk: val.id,
            username: val.username,
            full_name: val.full_name,
            biography: val.biography,
            following_count: val.edge_follow.count,
            follower_count: val.edge_followed_by.count,
            media_count: val.edge_owner_to_timeline_media.count,
            is_private: val.is_private,
            is_verified: val.is_verified,
            is_business: val.is_business_account,
            picture: val.profile_pic_url,
            picture_hd: val.profile_pic_url_hd,
            public_email: val.business_email,
            contact_phone_number: val.business_phone_number,
            bussiness_category_name: val.business_category_name,
            category_name: val.category_name,
          };
          this.saveInstagram(data);
        })
        .catch((err) => {
          this.loading = false;
          console.log(err);
        });
    },

    saveInstagram(data) {
      // console.log(data);
      var today = new Date();
      var time = today.toLocaleString("en-US", { timeZone: "Asia/Jakarta" });
      var data_ig = {
        id_target: "",
        user_id: data.pk,
        account: data.username,
        full_name: data.full_name,
        bio: data.biography,
        following: data.following_count,
        followers: data.follower_count,
        media: data.media_count,
        is_private: data.is_private,
        is_verified: data.is_verified,
        is_business: data.is_business,
        picture: this.avatar_instagram,
        picture_hd: null,
        public_email: data.public_email,
        contact_phone_number: data.contact_phone_number,
        bussiness_category_name: data.business_category_name,
        category_name: data.category_name,
        updated_at: time,
      };
      // console.log(data_ig);
      SocmedService.createInstagram(data_ig)
        .then((response) => {
          if (response.status == 212) {
            Swal.fire("Instagram is Updated", "", "success");
          } else {
            Swal.fire(this.$t("alert.alert-save"), "", "success");
          }
          this.loading = false;
          (this.searchResult = ""),
            (this.searchKey = ""),
            this.$router.push("/instagram");
          this.listInstagram();
          this.search = false;
          this.dnf = false;
          this.searchResult = 0;
          this.result = false;
        })
        .catch((err) => {
          console.log(err);
        });
    },

    deleteInstagram(id) {
      Swal.fire({
        title: this.$t("button.delete.modal.confirmText[0]"),
        text: this.$t("button.delete.modal.confirmText[1]"),
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        cancelButtonText: this.$t("button.cancel.text"),
        confirmButtonText: this.$t("button.delete.text"),
      }).then((result) => {
        if (result.isConfirmed) {
          SocmedService.deleteInstagram(id)
            .then((response) => {
              this.listInstagram();
              Swal.fire({
                position: "top-end",
                icon: "success",
                title: this.$t("alert.alert-delete-instagram"),
                showConfirmButton: false,
                timer: 1500,
              });
            })
            .catch((err) => {
              console.log(err);
            });
        }
      });
    },

    bulkAction() {
      Swal.fire({
        title: this.$t("button.delete.modal.confirmText[0]"),
        text: this.$t("button.delete.modal.confirmText[1]"),
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        cancelButtonText: this.$t("button.cancel.text"),
        confirmButtonText: this.$t("button.delete.text"),
      }).then((result) => {
        if (result.isConfirmed) {
          var data = this.selected;
          SocmedService.deleteBulkInstagram(data)
            .then((response) => {
              this.selected = [];
              this.listInstagram();
              Swal.fire({
                position: "top-end",
                icon: "success",
                title: this.$t("alert.alert-delete-instagram"),
                showConfirmButton: false,
                timer: 1500,
              });
            })
            .catch((err) => {
              console.log(err);
            });
        }
      });
    },

    pin(id) {
      const idt = btoa(id);
      Swal.fire({
        title: "Pin",
        text: "Pin Account",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        cancelButtonText: this.$t("button.cancel.text"),
        confirmButtonText: "Pin",
      }).then((result) => {
        if (result.isConfirmed) {
          console.log("id", idt);
          SocmedService.pinInstagram(idt)
            .then((response) => {
              this.listInstagram();
              Swal.fire({
                position: "top-end",
                icon: "success",
                title: response.data.message,
                showConfirmButton: false,
                timer: 1500,
              });
            })
            .catch((err) => {
              console.log(err);
            });
        }
      });
    },

    unpin(id) {
      const idt = btoa(id);
      Swal.fire({
        title: "Unpin",
        text: "Unpin Account",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        cancelButtonText: this.$t("button.cancel.text"),
        confirmButtonText: "Unpin",
      }).then((result) => {
        if (result.isConfirmed) {
          console.log("id", idt);
          SocmedService.unpinInstagram(idt)
            .then((response) => {
              this.listInstagram();
              Swal.fire({
                position: "top-end",
                icon: "success",
                title: response.data.message,
                showConfirmButton: false,
                timer: 1500,
              });
            })
            .catch((err) => {
              console.log(err);
            });
        }
      });
    },

    formatDate(value) {
      return moment(value).format("dddd, YYYY-MM-DD hh:mm");
    },

    removeSpace(value) {
      let str = value.replace(/\s/g, "");
      return str;
    },
  },
  mounted() {
    this.totalRows = this.items.length;
    this.getPreferencesSearch();
    this.getPreferencesSearch2();
    this.getPreferencesUserInfo();
    this.getPreferencesUserInfo2();
    this.listInstagram();
    this.getPreferencesAvatar();
  },
};
</script>

<style scoped>
.loading {
  padding-top: 20%;
  padding-bottom: 20%;
}
</style>
